export default "__VITE_ASSET__ceYaf0BiqlvrKpQrMEua_A__"